import { MenuItem, Select } from "@mui/material";
import "./MultiLang.css";

const MultiLang = ({
  t,
  baseLang,
  languageTabs,
  languageOptions,
  activeLang,
  addLanguageTab,
  removeLanguageTab,
  setActiveLang,
  getLangLabel,
}) => {
  return (
    <div className="lang-selector-container">
      <div className="lang-select">
        <label className="lang-select-label">
          {t("createDataOfferingsDetail.detail.addLanguage")}
        </label>
        <Select
          className="lang-select-input"
          displayEmpty
          value=""
          onChange={(e) => {
            const code = e.target.value;
            if (code) {
              addLanguageTab(code);
            }
          }}
          sx={{
            "& .MuiSelect-select": {
              padding: "8px 16px 8px 12px",
              fontSize: "14px",
            },
            "& fieldset": {
              border: "none",
            },
            width: "240px",
            height: "34px",
          }}
        >
          <MenuItem value="">
            {t("createDataOfferingsDetail.detail.translation")}
          </MenuItem>
          {languageOptions
            .filter(
              (o) => o.code !== baseLang && !languageTabs.includes(o.code)
            )
            .map((opt) => (
              <MenuItem key={opt.code} value={opt.code}>
                {opt.label}
              </MenuItem>
            ))}
        </Select>
      </div>
      <div className="lang-tabs">
        <button
          type="button"
          className={`lang-tab ${activeLang === "" ? "active" : ""}`}
          onClick={() => setActiveLang("")}
        >
          {t("createDataOfferingsDetail.detail.default")} ({baseLang})
        </button>
        {languageTabs.map((lang) => (
          <div key={lang} className="lang-tab-wrapper">
            <button
              type="button"
              className={`lang-tab ${activeLang === lang ? "active" : ""}`}
              onClick={() => setActiveLang(lang)}
            >
              {getLangLabel(lang)}
            </button>
            <button
              type="button"
              title={t("createDataOfferingsDetail.detail.remove")}
              onClick={() => {
                removeLanguageTab(lang);
              }}
              className="lang-remove-btn"
            >
              X
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiLang;
